import React from 'react';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import { Group, Radio, Text } from '@mantine/core';

export type RadioOption = {
  value: string;
  label: string;
};

interface RadioInputProps {
  name: string;
  label: string;
  classes?: string;
  error?: string;
  description?: string;
  withAsterisk?: boolean;
  options: RadioOption[];
  field: {
    onChange: (value: any) => void;
    onBlur: () => void;
    value: any;
  };
}

const RadioInput: React.FC<RadioInputProps> = ({
  label,
  options,
  classes = '',
  name,
  error,
  description,
  field,
  withAsterisk
}) => {
  return (
    <>
      <Radio.Group
        {...field}
        className={`container-radio-button ${classes}`}
        name={name}
        label={label}
        error={error}
        description={description}
        withAsterisk={withAsterisk}
      >
        <Group mt="xs">
          {options.map((option) => (
            <Radio
              key={option.value}
              value={option.value}
              label={option.label}
            />
          ))}
        </Group>
      </Radio.Group>
    </>
  );
};

export default RadioInput;
